import { checkScreenSize } from './utils.client';
import { useEffect, useState } from 'react';

type UseMobileDetectorOptions = {
  initialValue?: boolean;
};

export const useMobileDetector = ({ initialValue = false }: UseMobileDetectorOptions = {}) => {
  const [isMobileScreen, setIsMobileScreen] = useState(initialValue);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    setIsMobileScreen(checkScreenSize());
    const handleResize = () => setIsMobileScreen(checkScreenSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isMobileScreen };
};
